import { render } from "./ConsentItem.vue?vue&type=template&id=b2565880&scoped=true"
import script from "./ConsentItem.vue?vue&type=script&lang=js"
export * from "./ConsentItem.vue?vue&type=script&lang=js"

import "./ConsentItem.vue?vue&type=style&index=0&id=b2565880&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2565880"]])

export default __exports__